import { render, staticRenderFns } from "./UserProfileCoursesList.vue?vue&type=template&id=7dcd95be&scoped=true"
import script from "./UserProfileCoursesList.vue?vue&type=script&lang=js"
export * from "./UserProfileCoursesList.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCoursesList.vue?vue&type=style&index=0&id=7dcd95be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcd95be",
  null
  
)

export default component.exports